// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__W5JPW","darkTheme":"Footer_darkTheme__3BlVE","lightTheme":"Footer_lightTheme__LoJtN","connectionLinkGrid":"Footer_connectionLinkGrid__3lh5p"};